import { isProductBundle } from '~/types/Product';

import type { CartItem } from './interfaces';

export const isWarehouseStockTracked = (item: CartItem): boolean =>
  !isProductBundle(item);

export const isCartItemInWarehouseStock = (
  item: CartItem,
  warehouseCode?: string,
): boolean =>
  !isWarehouseStockTracked(item) ||
  item.count <= Number(item.sellableWarehouses[`${warehouseCode}`] || 0);

export const areCartItemsInWarehouseStock = (
  items: CartItem[],
  warehouseCode?: string,
): boolean =>
  items.every((item) => isCartItemInWarehouseStock(item, warehouseCode));
